import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DownloadTemplatesDialog({
    open,
    handleClose,
    handleDownload,
}) {
    const [templates, setTemplates] = React.useState({
        CASE: false,
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTemplates({
            ...templates,
            [event.target.name]: event.target.checked,
        });
    };

    const handleSubmit = () => {
        handleDownload(templates);
        setTemplates({
            CASE: false,
        });
        handleClose();
    };

    const handleCancel = () => {
        setTemplates({
            CASE: false,
        });
        handleClose();
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>{'Download HDE Import Templates'}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description2">
                    Please select which template you would like to download.
                </DialogContentText>
                <FormControl
                    sx={{ m: 3 }}
                    component="fieldset"
                    variant="standard"
                >
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={templates.CASE}
                                    onChange={handleChange}
                                    name="CASE"
                                />
                            }
                            label="Case Template"
                        />
                    </FormGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button
                    onClick={handleSubmit}
                    variant={'contained'}
                    color={'primary'}
                    disabled={Object.values(templates).every(
                        (v) => v === false
                    )}
                >
                    Download
                </Button>
            </DialogActions>
        </Dialog>
    );
}
